module.exports = __webpack_public_path__ + "img/conheca_icone_03.744b7c8e.png";